import { Chart } from "@antv/g2";
import * as _ from "@antv/util";
import React, { useEffect, useRef } from "react";
import { theme } from "antd";

export default function BarChart({
  data = [],
  x = "date",
  y = "value",
  xAxisTitle = "",
  yAxisTitle = "",
  showXAxisTitle = true,
  showYAxisTitle = true,
  color = "name",
  labelFontSize = 14,
  style = {},
}) {
  const container = _.uniqueId("barchart-");
  const chartRef = useRef(null);
  const { token } = theme.useToken();

  useEffect(() => {
    chartRef.current?.clear();
    const chartContainer = document.getElementById(container);
    chartContainer.innerHTML = "";

    const chart = new Chart({
      container: container,
      width: container.offsetWidth,
      height: container.offsetHeight,
      padding: "auto",
      autoFit: true,
    });

    chart
      .interval()
      .data(data)
      .encode("x", x)
      .encode("y", y)
      .encode("color", color)
      .legend("color", {
        position: "bottom",
        itemMarkerSize: 10,
        itemLabelFontSize: 10,
        itemLabelFill: token.colorTextBase,
        itemValueFontSize: 1,
      })
      .axis("y", {
        title: showYAxisTitle ? (yAxisTitle !== "" ? yAxisTitle : y) : false,
        titleFill: token.colorTextBase,
        titleFontSize: 12,
        line: true,
        lineStroke: token.colorTextBase,
        label: true,
        labelFill: token.colorTextBase,
        labelFontSize: labelFontSize,
      })
      .axis("x", {
        title: showXAxisTitle ? (xAxisTitle !== "" ? xAxisTitle : x) : false,
        titleFill: token.colorTextBase,
        line: true,
        lineStroke: token.colorTextBase,
        label: true,
        labelFill: token.colorTextBase,
        labelFontSize: labelFontSize,
      })
      .transform({ type: "stackY" })
      .interaction("tooltip", {
        render: (event, { title, items }) => {
          return `<div style="width:150px;">
            <h3 style="padding:0;margin:0">${title}</h3>
            <ul style="padding: 0; margin: 0; list-style: none;">
              ${items
                .map((d) => {
                  // Format the value with commas and 2 decimal places
                  const formattedValue = d.value
                    ? Number(d.value).toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : d.value === 0
                    ? Number(d.value).toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : d.value;
                  return `
                    <li style="display: flex; justify-content: space-between; align-items: center; margin: 4px 0;">
                      <span style="display: inline-flex; align-items: center;">
                        <span style="width: 8px; height: 8px; background-color: ${d.color}; border-radius: 50%; margin-right: 8px;"></span>
                        <span>${d.name}</span>
                      </span>
                      <span>${formattedValue}</span>
                    </li>`;
                })
                .join("")}
            </ul>
          </div>`;
        },
      });

    // put this so that the tooltip can be shown correctly
    chart
      .line()
      .data([])
      .encode("x", x)
      .encode("y", y)
      .encode("color", color)
      .encode("shape", "smooth")
      .style("stroke", "#fdae6b")
      .style("lineWidth", 2);

    chart.render();

    chartRef.current = chart;

    return () => {
      chartRef.current?.destroy();
    };
  }, [token, data]);

  useEffect(() => {
    const chartContainer = document.getElementById(container);
    const resizeObserver = new ResizeObserver(() => {});

    resizeObserver.observe(chartContainer);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <>
      <div style={style} id={container}></div>
    </>
  );
}
